import { CoreDataContext } from "../components/Layout";
import CustomLink from "./CustomLink";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./Address.module.css";
import { useContext } from "react";

export default function Address({ className = "" }) {
  const { addressData } = useContext(CoreDataContext);
  return (
    <CustomLink
      href={addressData.googleMapsUrl}
      className={classNames(className, styles.Address)}
    >
      <p>{addressData.address1}</p>
      <p>{addressData.address2}</p>
      <p>{addressData.address3}</p>
      <p>{addressData.address4}</p>
    </CustomLink>
  );
}

Address.propTypes = {
  className: PropTypes.string,
};
